import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import styled, { keyframes } from 'styled-components';

const slidingAnimation = keyframes `
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;
const StyledMediaCardSkeletonContainer = styled(FlexContainer) `
  position: relative;
  width: 250px;
  overflow: hidden;
  flex-shrink: 0;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background: ${props => props.theme.gradients.mediaCardSkeletonLoading};
    animation: ${slidingAnimation};
    animation-duration: ${props => props.theme.animation.duration.medium};
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    width: 300px;
  }
`;
const StyledMediaCardSkeletonHero = styled.div `
  background-color: ${props => props.theme.colors.mediaCardLoadingBackground};
  height: 141px;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    height: 169px;
  }
`;
const StyledMediaCardSkeletonLine = styled.div `
  background-color: ${props => props.theme.colors.mediaCardLoadingBackground};
  height: 13px;
  width: ${props => props.width};
  border-radius: 3px;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    height: 15px;
    border-radius: 4px;
  }
`;

export { StyledMediaCardSkeletonContainer, StyledMediaCardSkeletonHero, StyledMediaCardSkeletonLine };
//# sourceMappingURL=MediaCardSkeleton.styles.mjs.map
